<!-- Phone ☰ menu: drops down from the top left with every page, then the PayPal donation button, a divider, Search, How it works, Settings and Profiles -->
<script setup lang="ts">
import { MAIN_SECTIONS, SUB_TABS, type PageId } from '../navigation'
import { useUiStore } from '../stores/ui'
import { usePage } from '../composables/usePage'
import { useI18n } from '../composables/useI18n'
import { useCloudStore } from '../stores/cloud'
import { useDialogsStore } from '../stores/dialogs'
import DonateButton from './DonateButton.vue'

const ui = useUiStore()
const dialogs = useDialogsStore()
const { page, section, goTo } = usePage()
const { t } = useI18n()
const cloud = useCloudStore()
const go = (p: PageId) => { ui.closeMobileMenu(); goTo(p) }
const run = (f: () => void) => { ui.closeMobileMenu(); f() }
const itemCls = (on: boolean, sub = false) => ['w-full flex items-center gap-3', sub ? 'pl-11 pr-3 py-2 text-[13px]' : 'px-3 py-2.5 font-semibold',
  'rounded-xl text-left', on ? 'bg-brand/15 text-brand' : 'text-gray-200 hover:bg-darkbtn']
const iconCls = (icon: string, on: boolean, sub = false) => ['fas', icon, sub ? 'text-xs w-4' : 'w-5', 'text-center', on ? '' : 'text-gray-500']
</script>

<template>
  <div v-show="ui.mobileMenuOpen" id="mobileMenu" class="md:hidden fixed inset-0 top-14 z-40 bg-black/60" @click.self="ui.closeMobileMenu()">
    <div v-if="ui.mobileMenuOpen" id="mobileMenuPanel" class="mobile-menu-in bg-darkcard border-r border-b border-gray-800 w-[85vw] max-w-xs max-h-full overflow-y-auto rounded-br-2xl p-3 space-y-0.5 text-sm shadow-2xl">
      <template v-for="[sec, l, icon, first] in MAIN_SECTIONS" :key="sec">
        <button type="button" :class="itemCls(section === sec && !SUB_TABS[sec])" @click="go(first)">
          <i :class="iconCls(icon, section === sec && !SUB_TABS[sec])"></i><span class="truncate">{{ l }}</span>
        </button>
        <button v-for="[sub, subLabel, subIcon] in SUB_TABS[sec] || []" :key="sub" type="button" :class="itemCls(page === sub, true)" @click="go(sub)">
          <i :class="iconCls(subIcon, page === sub, true)"></i><span class="truncate">{{ subLabel }}</span>
        </button>
      </template>
      <DonateButton menu @open="ui.closeMobileMenu()" />
      <div class="border-t border-gray-800 my-2"></div>
      <button type="button" :class="itemCls(false)" @click="run(() => dialogs.show('search', {}))">
        <i :class="iconCls('fa-magnifying-glass', false)"></i><span class="truncate">{{ t('Search') }}</span>
      </button>
      <button type="button" :class="itemCls(page === 'help')" @click="go('help')">
        <i :class="iconCls('fa-book-open', page === 'help')"></i><span class="truncate">{{ t('How it works') }}</span>
      </button>
      <button type="button" :class="itemCls(page === 'settings')" @click="go('settings')">
        <i :class="iconCls('fa-gear', page === 'settings')"></i><span class="truncate">{{ t('Settings') }}</span>
      </button>
      <button type="button" :class="itemCls(false)" @click="run(cloud.openProfiles)">
        <i :class="iconCls('fa-user', false)"></i><span class="truncate">{{ t('Profile, projects and saving') }}</span>
      </button>
    </div>
  </div>
</template>
